var map = {
	"./general/DocsIcon--bluecheckmark.svg": 1466,
	"./general/DocsIcon--country.svg": 1467,
	"./general/DocsIcon--github.svg": 1468,
	"./general/DocsIcon--guide.svg": 1469,
	"./general/DocsIcon--list.svg": 1470,
	"./general/DocsIcon--locale.svg": 1471,
	"./general/DocsIcon--thumbsdown.svg": 1472,
	"./general/DocsIcon--thumbsup.svg": 1473,
	"./general/DocsIcon--video.svg": 1474,
	"./nav/DocsIcon--account.svg": 1475,
	"./nav/DocsIcon--business.svg": 1476,
	"./nav/DocsIcon--developertools.svg": 1477,
	"./nav/DocsIcon--financialservices.svg": 1478,
	"./nav/DocsIcon--home.svg": 1479,
	"./nav/DocsIcon--mobilenav.svg": 1480,
	"./nav/DocsIcon--payments.svg": 1481,
	"./nav/DocsIcon--reference.svg": 1482,
	"./nav/DocsIcon--security.svg": 1483,
	"./product/DocsIcon--account.svg": 1484,
	"./product/DocsIcon--atlas.svg": 1485,
	"./product/DocsIcon--capital.svg": 1486,
	"./product/DocsIcon--checkout.svg": 1487,
	"./product/DocsIcon--climate.svg": 1488,
	"./product/DocsIcon--connect.svg": 1489,
	"./product/DocsIcon--corporatecard.svg": 1490,
	"./product/DocsIcon--dashboard.svg": 1491,
	"./product/DocsIcon--developertools.svg": 1492,
	"./product/DocsIcon--elements.svg": 1493,
	"./product/DocsIcon--gateddocs.svg": 1494,
	"./product/DocsIcon--identity.svg": 1495,
	"./product/DocsIcon--implementationguides.svg": 1496,
	"./product/DocsIcon--invoicing.svg": 1497,
	"./product/DocsIcon--issuing.svg": 1498,
	"./product/DocsIcon--partners.svg": 1499,
	"./product/DocsIcon--payments.svg": 1500,
	"./product/DocsIcon--radar.svg": 1501,
	"./product/DocsIcon--reporting.svg": 1502,
	"./product/DocsIcon--sigma.svg": 1503,
	"./product/DocsIcon--styleguide.svg": 1504,
	"./product/DocsIcon--tax.svg": 1505,
	"./product/DocsIcon--terminal.svg": 1506,
	"./product/DocsIcon--treasury.svg": 1507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1465;